<template>
    <div class="history-table">
        <table class="history-table__table-striped">
            <thead>
                <tr>
                    <th class="w-12">
                        No.
                    </th>
                    <th class="w-12">Ngày</th>
                    <th class="w-20">Loại đề</th>
                    <th class="w-14">Số</th>
                    <th class="w-10">Tiền đánh</th>
                    <th class="w-10">Tiền thắng</th>
                    <th class="w-10 pl-2 text-left position-relative">
                        <Select
                            @change="changeFilter"
                            :value="valueFilter"
                            :options="optionFilter"
                            id="filterDisplay"
                            class="history__select-display"
                        />
                    </th>
                    <th class="w-12">Cược lại</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(historyBet, index) in filterHistoryBet"
                    :key="index"
                >
                    <td class="text-left">{{ historyBet.id }}</td>
                    <td class="text-center">
                        {{
                            historyBet.date.concat(
                                '-' +
                                    new Date(
                                        historyBet.created_at.substr(0, 10),
                                    ).getFullYear(),
                            )
                        }}
                    </td>
                    <td class="text-left">
                        {{
                            historyBet.city.name.concat(
                                ' ' + historyBet.category.name,
                            )
                        }}
                    </td>
                    <td class="text-left">
                        <template v-if="historyBet.numbers">
                            <CircleNumber
                                v-for="(number,
                                index) in historyBet.numbers.split(' - ')"
                                :key="index"
                                :numberInput="number"
                            />
                        </template>
                    </td>
                    <td class="text-right">
                        {{
                            (historyBet.amount / Number(clientBalanceUnit))
                                | currency_not_symbol
                        }}
                    </td>
                    <td class="text-right">
                        {{
                            (historyBet.amount_win / Number(clientBalanceUnit))
                                | currency_not_symbol
                        }}
                    </td>
                    <td class="text-left">
                        <span
                            :class="[
                                historyBet.status === Status.WIN
                                    ? 'win'
                                    : historyBet.status === Status.LOST
                                    ? 'lost'
                                    : 'waiting',
                            ]"
                            >{{
                                historyBet.status === Status.WIN
                                    ? 'Đã thắng'
                                    : historyBet.status === Status.LOST
                                    ? 'Đã thua'
                                    : 'Đang chờ'
                            }}</span
                        >
                    </td>
                    <td>
                        <Button
                            @click="clickPlayAgain(historyBet)"
                            value="Chơi Lại"
                            class="classes row-history__right--btn-play-now history-button__custom"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="history-table__page-navigation">
            <paginate
                v-model="updateCurrentPage"
                :page-count="pageCount"
                :page-range="9"
                :margin-pages="1"
                :click-handler="clickChangePage"
                :prev-text="'‹'"
                :next-text="'›'"
                :container-class="'history-pagination'"
                :page-class="'page-history-item'"
                :page-link-class="'page-history-link'"
                :next-link-class="'next-link'"
                :prev-link-class="'prev-link'"
                :next-class="'next-class'"
                :prev-class="'prev-class'"
            >
            </paginate>
        </div>
    </div>
</template>

<script>
import CircleNumber from '../CircleNumber/CircleNumber';
import Button from '../Button/Button';
import Select from '@/components/common/Select/Select';

const Status = {
    WIN: 1,
    LOST: 2,
    WAITING: 0,
};
export default {
    components: {
        CircleNumber,
        Button,
        Select,
    },
    props: {
        historyBets: Array,
        pageCount: Number,
        currentPage: {
            type: Number,
            require: false,
            default: 1,
        },
        optionFilter: {
            type: Array,
            require: false,
            default: () => [
                {
                    name: 'Kết quả',
                    value: -1,
                },
            ],
        },
    },
    data() {
        return {
            historyBetsBK: this.historyBets,
            Status: Status,
            clientBalanceUnit: process.env.VUE_APP_CLIENT_BALANCE_UNIT,
            valueFilter: {
                name: 'Kết quả',
                value: -1,
            },
            page: 3,
        };
    },
    methods: {
        clickChangePage(pageNum) {
            this.valueFilter = {
                name: 'Kết quả',
                value: -1,
            };
            this.$emit('change-page', pageNum);
        },

        clickPlayAgain(result) {
            this.$emit('play-again', result);
        },

        changeFilter(e) {
            this.valueFilter = e;
        },
    },
    computed: {
        filterHistoryBet() {
            let data = this.historyBets;
            if (this.valueFilter.value !== -1) {
                data = this.historyBets.filter(v => {
                    return v.status === this.valueFilter.value;
                });
            }
            return data;
        },

        updateCurrentPage: {
            get() {
                return this.currentPage;
            },
            set(newValue) {
                this.$emit('change', newValue);
            },
        },
    },
};
</script>
<style scoped lang="scss">
@import 'HistoryTablePC';
</style>
